import { Layout } from 'antd';
import React from 'react';
import cn from 'classnames';
import AppFooter from './AppFooter/AppFooter';
import AppHeader from './AppHeader/AppHeader';
import { BlockNavigation } from './AppHeader/AppHeader.types';
import styles from './AppLayout.module.scss';
import { useLocation } from 'react-router-dom';

interface AppLayoutProps extends BlockNavigation {
	className?: string;
	header?: React.ReactNode;
	headerTheme?: 'light';
	contentAddon?: React.ReactNode;
}

const AppLayout: React.FC<AppLayoutProps> = ({
	className,
	headerTheme,
	header,
	contentAddon,
	blockNavigation,
	children
}) => {
	const { pathname } = useLocation();
	const isLMS = pathname.includes('learning-manager');
	return (
		<Layout className={cn(styles.root, className)}>
			{contentAddon}
			{!isLMS && (
				<Layout.Header
					className={cn({
						[styles.themeLight]: headerTheme === 'light'
					})}
				>
					{header ||
						(header !== null && (
							<AppHeader blockNavigation={blockNavigation} />
						))}
				</Layout.Header>
			)}
			<Layout.Content>{children}</Layout.Content>
			{!isLMS && <AppFooter />}
		</Layout>
	);
};

export default AppLayout;
